export default function getGridInstance(ref: any): any {
  if (typeof ref !== 'undefined' &&
       typeof ref.$refs !== 'undefined' &&
       ref.$refs.dxdatagrid) {
    const grid = ref.$refs.dxdatagrid.instance;
    if (typeof grid !== 'object') {
      return null;
    }
    return grid;
  }
}
